import { IActivationLight } from '../tools/api.service';

export class ActivationLight {
  scaleCode: string;
  ctcFirstName: string;
  ctcName: string;
  ctcMail: string;
  ctcLogin: string;
  activationDate: string;
  licenceStart: string;
  licenceEnd: string;
  activationID: number;
  userName: string;
  userFirstName: string;
  userMail: string;
  userLoginUnisite: string;
  payorName: string;
  payorFirstName: string;
  payorMail: string;
  payorLoginUnisite: string;
  activationStatus: number;
  companyUnisiteCode: string;
  companySocialReason: string;
  companyAddress: string;
  companyPostalCode: string;
  companyCity: string;
  companyPayorUnisiteCode: string;
  companyPayorSocialReason: string;
  companyPayorAddress: string;
  companyPayorPostalCode: string;
  companyPayorCity: string;
  activationCode: string;
  isChecked: number;
  sageCode: string;
  invoiceCode: string;
  invoiceDate: string;
  billingID: number;
  transStatus: number;
  transDate: string;

  public static parseToActivationLight(item: IActivationLight): ActivationLight {
    let result = new ActivationLight();
    result.billingID = item.billingID;
    result.scaleCode = item.scaleCode;
    result.ctcFirstName = item.ctcFirstName;
    result.ctcName = item.ctcName;
    result.ctcLogin = item.ctcLogin;
    result.ctcMail = item.ctcMail;
    result.activationDate = item.activationDate;
    result.licenceStart = item.licenceStart;
    result.licenceEnd = item.licenceEnd;
    result.activationID = item.activationID;
    result.userName = item.userName;
    result.userFirstName = item.userFirstName;
    result.userMail = item.userMail;
    result.userLoginUnisite = item.userLoginUnisite;
    result.payorName = item.payorName;
    result.payorFirstName = item.payorFirstName;
    result.payorMail = item.payorMail;
    result.payorLoginUnisite = item.payorLoginUnisite;
    result.activationStatus = item.activationStatus;
    result.companyUnisiteCode = item.companyUnisiteCode;
    result.companySocialReason = item.companySocialReason;
    result.companyAddress = item.companyAddress;
    result.companyPostalCode = item.companyPostalCode;
    result.companyCity = item.companyCity;
    result.companyPayorUnisiteCode = item.companyPayorUnisiteCode;
    result.companyPayorSocialReason = item.companyPayorSocialReason;
    result.companyPayorAddress = item.companyPayorAddress;
    result.companyPayorPostalCode = item.companyPayorPostalCode;
    result.companyPayorCity = item.companyPayorCity;
    result.activationCode = item.activationCode;
    result.isChecked = item.isChecked;
    result.sageCode = item.sageCode;
    result.invoiceCode = item.invoiceCode;
    result.transDate = item.transDate;
    result.transStatus = item.transStatus;
    result.invoiceDate = item.invoiceDate;
    return result;
  }
}
